import React, {Component} from 'react';
import { Button, Icon, Modal, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { generateLoginOTPEmail, verifyLoginOTPEmail2, resetLoginOTPEmail, setRemindUpdatePassword } from '../../actions';
import { withRouter } from 'react-router';
import { Formik, Form, Field } from "formik";
import { LoginOTPSchema } from "../../component/forms/login/validate";
import FormsInputsText from "../../component/forms/inputs/text/forms_inputs_text";

class VerifyOtpModal extends Component {
    state = {
        error: false,
        errorMessage: null,
    };

    componentDidMount() {
        this.props.generateLoginOTPEmail({nric: this.props.user.nric}, (result, error)=>{
        if (error) {
            this.setState({ error: true, errorMessage: error.errorMessage });
            return;
            }
        })
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry. {this.state.errorMessage}</Message.Header>
                </Message>
            );
        }
    }
    
    render() {
        return (
            <Modal
              open={!this.props.isVerified}
              size="small"
            >
                <Modal.Content>
                <Formik
                       initialValues={{ otp: "" }}
                       onSubmit={(values, actions) => {
                           console.log(values, actions);
                           this.setState({ error: false, errorMessage: "" });
                           this.props.verifyLoginOTPEmail2({nric: this.props.user.nric, otp: values.otp, accessToken: this.props.user.accessToken }, (result, error) => {
                            console.log("check result after verify", result)
                               if (error) {
                                    console.log("error is here", result)
                                    actions.resetForm();
                                    this.setState({ error: true, errorMessage: error.errorMessage });
                                    return;
                                }
                                actions.setSubmitting(false);
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                });
                            });
                       }}
                       validateOnBlur={false}
                       validateOnChange={false}
                       validationSchema={LoginOTPSchema}
                       render={({ isSubmitting }) => (
                            <Form className="ui form">
                                <Message positive>
                                        <Message.Header >
                                            {this.props.OTPtype && this.props.OTPtype === 'EMAIL' ? 'Check your Email!' : 'Check your Phone!'}
                                        </Message.Header>
                                    <p>
                                        An OTP verification has been sent to {this.props.user ? this.props.OTPtype && this.props.OTPtype === 'EMAIL' ? this.props.user.email : "your registered phone number" : "your registered phone number"}.
                                    </p>
                                </Message>

                                <Field name="otp" label="One Time Password" component={FormsInputsText} secondaryLabel=""/>
                                <div className="field">
                                    <Button id="submit" type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>
                                        Submit
                                    </Button>
                                </div>
                                <div className="field">
                                    <Button
                                        id="back-login"
                                        type="button"
                                        primary
                                        fluid
                                        onClick={() => {
                                            this.setState({
                                                error: false,
                                                errorMessage: null,
                                            });
                                            this.props.resetLoginOTPEmail();
                                            this.props.history.goBack()
                                        }}>
                                            Cancel
                                    </Button>
                                </div>
                                {this.renderFormSubmissionResult()}
                            </Form>
                       )}
                    />
                </Modal.Content>
            </Modal>
          )
    }
}
 
export default withRouter(connect(null, { generateLoginOTPEmail, verifyLoginOTPEmail2, resetLoginOTPEmail, setRemindUpdatePassword })(VerifyOtpModal));
